import { Checkbox, Form } from 'antd';
import React from 'react';
import styles from '../rules.module.scss';

const ExtendedVersioningCheckbox: React.FC<{
  name: string[];
  label: string;
  checked: boolean;
  onChange: () => void;
  gridArea: string;
}> = ({ name, label, checked, onChange, gridArea }) => (
  <Form.Item name={name} valuePropName="checked" className={styles.block} style={{ gridArea }}>
    <Checkbox onChange={onChange} checked={checked}>
      {label}
    </Checkbox>
  </Form.Item>
);

export default ExtendedVersioningCheckbox;
